/* eslint-disable */

import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
// material-ui
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { Avatar, Box, ButtonBase } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { useSelector, useDispatch } from 'react-redux';
import { increment } from 'redux/WalletSlice';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';

// assets
import { IconMenu2 } from '@tabler/icons';
import { useEffect } from 'react';
import { handleCatchError } from 'utils/CatchHandler';
import BcAgreement from './ProfileSection/BcAgreement';
import {
    checkMerchantOrBCAPI,
    checkPermissionGet,
    getRentalAgreementApi,
    premiumNotifyResponseApi,
    rekycOtpSendApi,
    signRentalAgreementApi
} from 'utils/API/Merchant APIs/MerchantApiCalls';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './index.css';
import { checkPermissionDistributor, signDistAgreementApi } from 'utils/API/Distributor APIs/DistributorAPiCalls';
import LoadingDialog from './Components/LoadingDialog';
import { logoutFunctionGlobal } from 'utils/useLogout';
import SummaryButton from './Components/SummaryButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import BalanceChip from './Components/BalanceChip';
import { listenForMessages, requestPermission } from 'hooks/useFirebaseMessaging';
import MessageDialog from 'views/Components/CommonCustomComponents/messageDialog/MessageNotification';
import Spinner from 'views/Components/LoadingSinner';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import OtpVerificationDialog from 'views/Components/Dialogs/OTPverificationDialog';
import { setDisablerFalse } from 'redux/SidebarDisablerSlice';
import RoleToggle from './Components/RoleToggle';
import { toggleRole } from 'redux/roleSlice';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //
const buttonVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.1,
            duration: 2,
            ease: 'easeOut'
        }
    })
};
const Header = ({ handleLeftDrawerToggle, premiumStatus }) => {
    const currentRoute = window.location.pathname;
    const role = useSelector((state) => state.role.role);
    const balanceW1 = useSelector((state) => state?.wallet?.balance?.roundedNumber);
    const balanceW2 = useSelector((state) => state?.wallet?.balance?.virtualBalance);
    const balanceW3 = useSelector((state) => state?.wallet?.balance?.wallet3Balance);
    const merchantModeBalance = useSelector((state) => state?.wallet?.balance?.merchantModeBalance);
    const showBc = useSelector((state) => state?.bcAgreement?.bcAgreementShow);
    // const valueW1 = isNaN(balanceW1) ? 0 : balanceW1;
    // const valueW2 = isNaN(balanceW2) ? 0 : balanceW2;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [consentStep, setConsentStep] = useState(1);
    const [virtualBalanceState, setVirtualBalance] = useState('');
    const type = localStorage.getItem('type');
    const employeeRole = localStorage.getItem('employeeRole');
    const [isShow, setIsShow] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPremiumBc, setIsPremiumBc] = useState(false);
    const [premiumLoading, setPremiumLoading] = useState(false);
    const [loading, setLoading] = useState({ permission: false, rentalAgreeing: false, rentAgreement: false });
    const [loadingOtp, setLoadingOtp] = useState({ sending: false, verifying: false, sent: false });
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [status, setStatus] = useState('loading'); // "loading", "pending", or "completed"
    const [isPending, setIsPending] = useState(false);
    const [agreeOrDisagree, setAgreeOrDisagree] = useState('');
    const [isNormalMerchantMode, setIsNormalMerchantMode] = useState(false);
    const [openPremiumMessage, setOpenPremiumMessage] = useState({
        open: false,
        content: '',
        isMandatory: false,
        heading: '',
        onAgreeText: '',
        onDisgreeText: ''
    });
    const [openRentalMessage, setOpenRentalMessage] = useState({
        open: false,
        content: '',
        isMandatory: false,
        heading: '',
        onAgreeText: '',
        onDisgreeText: '',
        status: 'false',
        htmlContent: ''
    });

    const open = Boolean(anchorEl);
    const theme = useTheme();
    const shouldShowW3 = localStorage.getItem('w3status');
    const mode = useSelector((state) => state.theme.mode);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isPublicMessagePage = location.pathname === '/public-message';
    const isHomePage = location.pathname === '/merchant-home';
    const isRentalRedirect = location.state?.isRentalRedirect;

    let agreed;
    let consentText;
    if (agreeOrDisagree === 'agree') {
        agreed = 1;
        consentText = openPremiumMessage.onAgreeText;
    } else if (agreeOrDisagree === 'disagree') {
        agreed = 0;
        consentText = openPremiumMessage.onDisgreeText;
    }
    const handleAgree = async () => {
        if (consentStep === 1) {
            setAgreeOrDisagree('agree');
            setConsentStep(2);
        } else {
            sendOtp();
        }
        // await managePremiumNotifyResponse();
        // setOpenPremiumMessage((prev) => ({ ...prev, open: false }));
    };

    const handleDisagree = () => {
        // sendOtp();
        if (consentStep === 2) {
            setConsentStep(1);
        } else {
            setAgreeOrDisagree('disagree');
            setConsentStep(2);
        }
        // setOpenPremiumMessage((prev) => ({ ...prev, open: false }));
    };
    const handleRentalDisagree = () => {
        setOpenRentalMessage((prev) => ({ ...prev, open: false }));
    };
    const handleDropdownClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleReload = () => {
        window.location.reload();
    };
    const handleLogout = () => {
        logoutFunctionGlobal();
    };
    const handleBackClick = () => {
        dispatch(setDisablerFalse());
        setOpenRentalMessage((prev) => ({ ...prev, open: false }));
        if (!isHomePage) {
            navigate('/merchant-home', { state: { isRentalRedirect: true } });
        }
    };

    const getRentalAgreement = async ({ isView }) => {
        if ((!isView && openRentalMessage.status === 'pending') || isRentalRedirect) {
            setOpenRentalMessage((prev) => ({ ...prev, open: false }));
            return;
        }
        isView ? setLoading((prev) => ({ ...prev, rentAgreement: true })) : setLoading((prev) => ({ ...prev, rentalAgreeing: true }));
        const payload = { agentid: localStorage.getItem('id'), view: isView };
        const response = await signRentalAgreementApi(payload);
        if (response.status === 200) {
            const html = response?.data?.data;
            if (isView) {
                setOpenRentalMessage((prev) => ({ ...prev, htmlContent: html }));
            } else {
                const innerTab = window.open('about:blank', 'Inner Tab', 'width=800,height=1000');
                if (innerTab) {
                    // Write HTML content to the new tab
                    innerTab.document.open();
                    innerTab.document.write(html);
                    innerTab.document.close();
                    handleBackClick();
                } else {
                    // Handle if the browser blocks popup
                    alert('Please allow popups for this site to open the inner tab.');
                }
            }
        }
        isView ? setLoading((prev) => ({ ...prev, rentAgreement: false })) : setLoading((prev) => ({ ...prev, rentalAgreeing: false }));
    };
    const sendOtp = async () => {
        setLoadingOtp((prev) => ({ ...prev, sending: true }));
        const response = await rekycOtpSendApi();
        if (response?.status === 200) {
            setLoadingOtp((prev) => ({ ...prev, sent: true }));
            const phone = response?.data?.phone;
            globalNotifySuccess(`OTP has been sent to the phone number ${phone}`);
        }
        setLoadingOtp((prev) => ({ ...prev, sending: false }));
    };
    const managePremiumNotifyResponse = async (otp) => {
        setLoadingOtp((prev) => ({ ...prev, verifying: true }));
        const agent_id = localStorage.getItem('id');
        const payload = { agent_id, agreed, otp };
        const response = await premiumNotifyResponseApi(payload);
        if (response?.status === 200) {
            setLoadingOtp((prev) => ({ ...prev, sent: false }));
            globalNotifySuccess(response?.data?.message);
            checkPermissions();
        }
        setLoadingOtp((prev) => ({ ...prev, verifying: false }));
    };
    const checkIsMerchantOrBc = async () => {
        setPremiumLoading(true);
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const merchantBcCheckResponse = await checkMerchantOrBCAPI(payload);
        const eSignStatus = merchantBcCheckResponse?.data?.isESigned;
        const agentType = merchantBcCheckResponse?.data?.agentType;
        if (agentType != 'Merchant' && eSignStatus === false) {
            localStorage.setItem('shouldshowEsign', true);
        } else {
            localStorage.setItem('shouldshowEsign', false);
        }
        if (agentType === 'Merchant') {
            setIsNormalMerchantMode(true);
        } else {
            setIsNormalMerchantMode(false);
        }
        setPremiumLoading(false);
        // setType(agentType);
    };

    const checkPermissions = async () => {
        //API TO CHECK PERMISSION FOR SETTLEMENT REQUEST
        setLoading((prev) => ({ ...prev, permission: true }));
        try {
            const response = await checkPermissionGet();
            if (response?.data?.status) {
                const dmtType = response?.data?.dmt_type;
                const bc_agent_status = response.data?.bc_agent_status;
                const merchantSchargePercentage = response.data?.merchant_settlement_service_charge;
                localStorage.setItem('dmtType', dmtType);
                localStorage.setItem('bc_agent_status', bc_agent_status);
                localStorage.setItem('kycKeyStatus', response.data?.matm_kyc_status);
                localStorage.setItem('merchantScharge', merchantSchargePercentage);
                const shouldOpenPremiumPopup = response?.data?.premium_renewal_popup?.popup_show;
                const contentText = response?.data?.premium_renewal_popup?.content;
                const mandatory = response?.data?.premium_renewal_popup?.is_mandatory;
                const dialogHeading = response?.data?.premium_renewal_popup?.head;
                const onAgreeText = response?.data?.premium_renewal_popup?.on_agree;
                const onDisagreeText = response?.data?.premium_renewal_popup?.on_disagree;
                const rmRentalCategory = response?.data?.rm_rental_category;
                const rmRentalStatus = response?.data?.RentalAggrement_status;
                localStorage.setItem('isRentalUser', rmRentalCategory);
                let isPendingNonHome = false;
                if (!isHomePage && rmRentalStatus === 'pending') {
                    isPendingNonHome = true;
                } else if (isRentalRedirect) {
                    isPendingNonHome = true;
                }
                if (rmRentalStatus === 'rejected')
                    if (rmRentalCategory && !isHomePage && rmRentalStatus === '' && rmRentalStatus === 'rejected') {
                        navigate('/merchant-home', { state: true });
                    }
                setOpenPremiumMessage({
                    open: shouldOpenPremiumPopup,
                    content: contentText,
                    isMandatory: mandatory,
                    heading: dialogHeading,
                    onAgreeText: onAgreeText,
                    onDisgreeText: onDisagreeText
                });
                setOpenRentalMessage((prev) => ({
                    ...prev,
                    open: isPendingNonHome ? false : rmRentalCategory,
                    content:
                        rmRentalStatus === 'pending'
                            ? 'Your device rental agreement approval is pending, but you can proceed to use the services.'
                            : '',
                    isMandatory: true,
                    heading:
                        rmRentalStatus === 'pending'
                            ? ' Device Rental Agreement'
                            : rmRentalStatus === 'rejected'
                            ? 'Your rental device agreement application has been rejected. Kindly re-apply to continue.'
                            : '',
                    onAgreeText: onAgreeText,
                    onDisgreeText: onDisagreeText,
                    status: rmRentalStatus
                }));
            }
            setLoading((prev) => ({ ...prev, permission: false }));

            // setIsTrue(false);
        } catch (error) {
            setLoading((prev) => ({ ...prev, permission: false }));
            // setIsTrue(false);
            handleCatchError(error);
            console.log(error.message);
        }
    };
    const esignDistAgreement = async () => {
        const user_id = localStorage.getItem('id');
        const payload = { user_id };
        const response = await signDistAgreementApi(payload);
        if (response?.status === 200) {
            const htmlContent = response?.data;
            const innerTab = window.open('about:blank', 'Inner Tab', 'width=800,height=1000');
            if (innerTab) {
                setStatus('');
                // Write HTML content to the new tab
                innerTab.document.open();
                innerTab.document.write(htmlContent);
                innerTab.document.close();
                // handleBackClick();
            } else {
                // Handle if the browser blocks popup
                alert('Please allow popups for this site to open the inner tab.');
            }
        }
    };
    const checkPermissionDist = async () => {
        setStatus('loading');
        const response = await checkPermissionDistributor();
        if (response?.status === 200) {
            setIsDialogOpen(true);
            if (response?.data?.essign_aggrement === 'false') {
                esignDistAgreement();
            } else if (response?.data?.essign_aggrement === 'true') {
                if (response?.data?.essign_aggrement_status === 'PENDING') {
                    setIsPending(true);
                    setStatus('pending');
                } else if (response?.data?.essign_aggrement_status === 'SUCCESS') {
                    setIsPending(false);
                    setIsDialogOpen(false);
                    const agreementLink = response?.data?.bccertificateLink;
                    localStorage.setItem('dist-esign-agreement', agreementLink);
                }
            } else if (response?.data?.essign_aggrement === 'empty') {
                setIsDialogOpen(false);
            }
        }
    };
    useEffect(() => {
        if (localStorage.getItem('isRentalUser') === 'true') {
            checkPermissions();
        }
    }, [location]);
    useEffect(() => {
        // fetchBalance();
        if (type === 'merchants') {
            dispatch(fetchWalletBalanceAsync());
            checkPermissions();
        } else if (type === 'distributor') {
            if (employeeRole === 'undefined' || employeeRole === '') {
                // checkPermissionDist();
            }
        }
    }, [type]);
    useEffect(() => {
        if (isNormalMerchantMode && role !== 'Merchant') {
            dispatch(toggleRole());
        }
    }, [isNormalMerchantMode, role]);
    useEffect(() => {
        if (openRentalMessage.status !== 'approved' && openRentalMessage.status !== 'false') getRentalAgreement({ isView: true });
    }, [openRentalMessage.status]);
    useEffect(() => {
        if (isPending && type === 'distributor') {
            if (currentRoute !== '/distributor/dashboard' && currentRoute !== '/distributor/profile') {
                navigate('/distributor/dashboard');
                setIsDialogOpen(true);
            }
        }
    }, [currentRoute]);

    const handleDialogClose = () => {
        if (isPending) {
            setIsDialogOpen(false);
            navigate('/distributor/dashboard');
        }
    };
    const handleClickMerchantBalance = () => {
        navigate('merchants/merchant-wallet');
        handleClose();
    };
    const handleClick = () => {
        navigate('merchants/wallet');
        handleClose();
    };
    const handleClickW2 = () => {
        navigate('merchants/transactions');
        handleClose();
    };
    const handleClickSummary = () => {
        navigate('profile-summary');
        handleClose();
    };
    const handleClickW3 = () => {
        navigate('merchants/wallet3');
        handleClose();
    };
    function handleBalance() {
        navigate('/merchants/transactions');
    }
    useEffect(() => {
        const type = localStorage.getItem('type');
        if (type === 'merchants') {
            setIsShow(true);
        }
        checkIsMerchantOrBc();
        requestPermission();
        listenForMessages();
    }, []);
    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    color: '#28282B',
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                {' '}
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden', flexGrow: 1 }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: mode === 'dark' ? 'linear-gradient(145deg, #1f1f1f, #0071bc)' : theme.palette.primary.light,
                            color: mode === 'dark' ? '#FFD700' : theme.palette.primary.dark,
                            '&:hover': {
                                background: mode === 'dark' ? 'linear-gradient(145deg, #1f1f1f, #0071bc)' : theme.palette.primary.dark,
                                color: theme.palette.primary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
                {showBc && <BcAgreement />}
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
            </Box>

            {/* header search */}
            <SearchSection />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {isShow && !premiumLoading && (
                <>
                    {role === 'Merchant' ? (
                        <motion.div custom={0} initial="hidden" animate="visible" variants={buttonVariants}>
                            <ButtonBase
                                className="wallet-button"
                                onClick={handleClickMerchantBalance}
                                sx={{ '&:hover': { cursor: 'pointer' }, ml: 1 }}
                            >
                                <BalanceChip heading="Merchant Balance" value={merchantModeBalance} mode={mode} />
                            </ButtonBase>
                        </motion.div>
                    ) : (
                        <>
                            <motion.div custom={0} initial="hidden" animate="visible" variants={buttonVariants}>
                                <ButtonBase
                                    className="wallet-button"
                                    onClick={handleClick}
                                    sx={{ '&:hover': { cursor: 'pointer' }, ml: 1 }}
                                >
                                    <BalanceChip heading="Main Balance" value={balanceW1} mode={mode} />
                                </ButtonBase>
                            </motion.div>
                            <motion.div custom={0} initial="hidden" animate="visible" variants={buttonVariants}>
                                <ButtonBase className="wallet-button" onClick={handleClickW2} sx={{ '&:hover': { cursor: 'pointer' } }}>
                                    <BalanceChip heading="Cash Out Balance" value={balanceW2} mode={mode} />
                                </ButtonBase>
                            </motion.div>
                            {shouldShowW3 === 'true' && (
                                <motion.div custom={2} initial="hidden" animate="visible" variants={buttonVariants}>
                                    <ButtonBase className="wallet-button" onClick={handleClickW3} sx={{ '&:hover': { cursor: 'pointer' } }}>
                                        <BalanceChip heading="Incentive Balance" value={balanceW3} mode={mode} />
                                    </ButtonBase>
                                </motion.div>
                            )}

                            {!isMobile ? <SummaryButton /> : null}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 2,
                                    '&:hover': { cursor: 'pointer' }
                                }}
                            >
                                <div className="wallet-dropdown">
                                    <Button
                                        id="basic-button"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleDropdownClick}
                                    >
                                        Wallets
                                    </Button>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button'
                                        }}
                                    >
                                        <MenuItem onClick={handleClick}>{`Main Balance(₹ ${balanceW1 ? balanceW1 : 0})`}</MenuItem>
                                        <MenuItem onClick={handleClickW2}>{`Cash Out Balance(₹ ${balanceW2 ? balanceW2 : 0})`}</MenuItem>
                                        <MenuItem onClick={handleClickSummary}>{`Profile Summary`}</MenuItem>
                                        {shouldShowW3 === 'true' && (
                                            <MenuItem onClick={handleClickW3}>{`Incentive Balance (₹ ${
                                                balanceW3 ? balanceW3 : 0
                                            })`}</MenuItem>
                                        )}
                                    </Menu>
                                </div>
                            </Box>
                        </>
                    )}
                    {/* <motion.div custom={3} initial="hidden" animate="visible" variants={buttonVariants}> */}
                    {!isNormalMerchantMode ? <RoleToggle mode={mode} isNormalMerchantMode={isNormalMerchantMode} /> : null}
                    {/* </motion.div> */}
                </>
            )}
            {/* <NotificationSection /> */}
            {!premiumLoading && <ProfileSection />}
            <LoadingDialog
                open={isDialogOpen}
                status={status}
                onReload={handleReload}
                onLogout={handleLogout}
                handleClose={handleDialogClose}
            />
            {loading.permission ? (
                <Spinner loading={loading.permission} />
            ) : (
                <>
                    <MessageDialog
                        //dialog for premium BC conversion message>>>>
                        open={openPremiumMessage.open && !isPublicMessagePage}
                        onClose={() => setOpenPremiumMessage((prev) => ({ ...prev, open: false }))}
                        title={openPremiumMessage?.heading}
                        message={consentStep === 1 ? openPremiumMessage?.content : consentText}
                        agreeText={consentStep === 1 ? 'I agree' : 'Confirm & send OTP'}
                        disagreeText={consentStep === 1 ? 'I disagree' : 'Cancel'}
                        onAgree={handleAgree}
                        onDisagree={handleDisagree}
                        showActions={true}
                        disableBackdropClick={true}
                        showCloseButton={!openPremiumMessage.isMandatory}
                        agreeLoading={loadingOtp.sending}
                        disAgreeLoading={loadingOtp.sending}
                    />
                    <MessageDialog
                        //dialod for rental agreement>>>>
                        open={
                            openRentalMessage.open &&
                            (openRentalMessage.status === '' ||
                                openRentalMessage.status === 'pending' ||
                                openRentalMessage.status === 'rejected')
                        }
                        onClose={() => setOpenRentalMessage((prev) => ({ ...prev, open: false }))}
                        title={openRentalMessage.heading}
                        message={openRentalMessage.content}
                        agreeText={openRentalMessage.status === 'pending' ? 'Okay' : 'Proceed'}
                        disagreeText=""
                        onAgree={() => getRentalAgreement({ isView: false })}
                        onDisagree={handleRentalDisagree}
                        showActions={true}
                        disableBackdropClick={true}
                        showCloseButton={!openRentalMessage.isMandatory}
                        agreeLoading={loading.rentalAgreeing || loading.permission || loading.rentAgreement}
                        disAgreeLoading={loadingOtp.sending}
                        htmlContent={openRentalMessage.htmlContent}
                        dialogWidth="1200px"
                    />
                    <OtpVerificationDialog
                        open={loadingOtp.sent}
                        onSubmit={managePremiumNotifyResponse}
                        verifying={loadingOtp?.verifying}
                        resending={loadingOtp?.sending}
                        onResend={sendOtp}
                        // onClose={handleOtpClose}
                    />
                </>
            )}
            <Spinner loading={loading.rentAgreement || loading.permission || loading.rentalAgreeing} />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
